module.exports = __webpack_public_path__ + "video/700_KMSAT15_2022_Internet_Based_Attacks-Fake_Profiles.8af705b3.vtt";